/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'
import { isAfterOrEqual } from 'util/date/compare'
import { formatDate } from 'util/date/formatDate'
import { humanizeDate } from 'util/date/humanize-date'

interface ImunobiologicoSectionProps {
  id: ID
  nomeImuno: string
  dataRegistro: Date
  dataInicioGestacao: Date
  isAprazada?: boolean
  showBorder?: boolean
}

export function ImunobiologicoSection(props: Readonly<ImunobiologicoSectionProps>) {
  const { nomeImuno, dataRegistro, dataInicioGestacao, showBorder = true, isAprazada = false } = props

  const theme = useTheme()
  const styles = createStyles(theme, showBorder)

  const hasIgDeInicio = dataRegistro && isAfterOrEqual(dataRegistro, dataInicioGestacao)
  const idadeGestacional =
    hasIgDeInicio && !isAprazada && humanizeDate(dataRegistro.getTime(), dataInicioGestacao.getTime())

  return (
    <VFlow vSpacing={0} style={styles.verticalDivider}>
      <Text fontWeight='bold'> {nomeImuno} </Text>
      <Text> {formatDate(dataRegistro.getTime())} </Text>
      {idadeGestacional && (
        <Text>
          {' '}
          <b>IG:</b> {idadeGestacional}{' '}
        </Text>
      )}
    </VFlow>
  )
}

const createStyles = (theme: Theme, showBorder: boolean) => ({
  verticalDivider: css`
    padding-right: 0.5rem;
    border-right: ${showBorder ? 1 : 0}px solid ${theme.pallete.divider};
  `,
})
